import { Component, Image, Label, Layout, TableRow } from "@mcleod/components";
import { DisplayType, ModelRow } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";

export class CommissionsProcessingUtil {
    static setComponentDetails(tableRow: TableRow) {
        const modelRow = tableRow.data as ModelRow;
        const imageOverriddenRate = tableRow.findComponentById("imageOverriddenRate") as Image;
        if (modelRow.getBoolean("override_rate", false) && imageOverriddenRate) {
            imageOverriddenRate.visible = true;
        }
    }

    static setTooltipContent(component: Component, modelRow: ModelRow) {
        switch (component.id) {
            case "labelOrderId": {
                CommonTooltips.setTooltipContentLayout(component, modelRow.get("movement_id"), "lme/settlement/OrderPayablesOrderIdQuickInfo");
                break;
            }
            case "textboxCommissionableMargin": {
                CommonTooltips.setTooltipContentLayout(component, modelRow.get("id"), "lme/settlement/commissions/CommMarginQuickInfo");
                break;
            }
            case "textboxSplitCommMargin": {
                CommonTooltips.setTooltipContentLayout(component, modelRow.get("id"), "lme/settlement/commissions/SplitCommMarginQuickInfo");
                break;
            }
            default: {
                if (component instanceof Label && component.displayType === DisplayType.STRING) {
                    component.tooltip = modelRow.get(component.field);
                }
            }
        }
    }

    static isCommissionsProcessingLayoutTab(layout: Layout): boolean {
        return "getLayoutBaseFilter" in layout && "tableCommissionsProcessing" in layout;
    }
}
